import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M2 20v-7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v7M2 17h20M4 11V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4m-8-6v6"
    }, null, -1)
  ])))
}
export default { render: render }